import { useEffect, useRef } from "react";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm(): void;
  onCancel(): void;
}

export function ConfirmDialog({ open, title, message, confirmLabel, onConfirm, onCancel }: ConfirmDialogProps): React.JSX.Element {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (!dialog.current) return;
    if (open && !dialog.current.open) dialog.current.showModal();
    if (!open && dialog.current.open) dialog.current.close();
  }, [open]);
  return <dialog ref={dialog} aria-labelledby="confirm-title" onCancel={event => { event.preventDefault(); onCancel(); }}>
    <form method="dialog" className="dialog-content">
      <h2 id="confirm-title">{title}</h2><p>{message}</p>
      <div className="actions"><button type="button" className="button-secondary" onClick={onCancel}>Keep current state</button><button type="button" className="button-danger" onClick={onConfirm}>{confirmLabel}</button></div>
    </form>
  </dialog>;
}
